import { useIsSizeRecommendationEnabled } from "@/hooks/use-is-size-recommendation-enabled";
import { useViewerDateFnsLocale } from "@/lib/translator";
import useTranslation from "@babackapp/translations/use-translation";
import { format, subMonths } from "date-fns";
import { SizingConfigDialog } from "./components/sizing-config-dialog";
import { SizingDailyRecommendationsChart } from "./components/sizing-daily-recommendations-chart";
import { SizingDiagnosticTable } from "./components/sizing-diagnostic-table";
import { SizingUpsellCallout } from "./components/sizing-upsell-callout";

export default function SizingPage() {
  const t = useTranslation();
  const locale = useViewerDateFnsLocale();
  const isSizingEnabled = useIsSizeRecommendationEnabled();

  if (!isSizingEnabled) {
    return (
      <div className="flex items-center justify-center">
        <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4">
          <div className="col-span-4 mb-4 space-y-2">
            <h2 className="text-2xl leading-6 font-semibold text-foreground">
              {t("sizing.pageTitle", {
                from: format(subMonths(Date.now(), 3), "d MMMM yyyy", { locale }),
                to: format(Date.now(), "d MMMM yyyy", { locale }),
              })}
            </h2>
            <p className="text-sm leading-relaxed text-muted-foreground max-w-[600px]">
              {t("sizing.pageSubtitle")}
            </p>
          </div>
          <SizingUpsellCallout />
          <SizingDailyRecommendationsChart isLocked />
          <SizingDiagnosticTable isLocked />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <div className="grid grid-cols-4 gap-4 w-full max-w-[1600px] lg:px-16 lg:py-6 px-6 py-4">
        <div className="col-span-4 mb-4 flex items-start justify-between gap-4">
          <div className="space-y-2">
            <h2 className="text-2xl leading-6 font-semibold text-foreground">
              {t("sizing.pageTitle", {
                from: format(subMonths(Date.now(), 3), "d MMMM yyyy", { locale }),
                to: format(Date.now(), "d MMMM yyyy", { locale }),
              })}
            </h2>
            <p className="text-sm leading-relaxed text-muted-foreground max-w-[600px]">
              {t("sizing.pageSubtitle")}
            </p>
          </div>
          <SizingConfigDialog />
        </div>
        <SizingDailyRecommendationsChart />
        <SizingDiagnosticTable />
      </div>
    </div>
  );
}
